import { createAction } from 'redux-actions';
import MerchantsType from '../types/MerchantsType';
import MerchantsService from '../../services/MerchantsService';
import { failedRequest, startRequest, successRequest } from './GlobalActions';
import { fetchGridFiltersSuccess } from './GridFiltersActions';

const fetchMerchantsSuccess = createAction(MerchantsType.actions.fetchMerchantsAllSuccess, (allMerchants) => ({ allMerchants }));

const fetchCountriesCurrencyData = createAction(MerchantsType.actions.fetchCountriesCurrencyData);

export const fetchMerchantsAll =
  (params = {}) =>
  (dispatch) => {
    dispatch(startRequest({ action: MerchantsType.actions.fetchMerchantsAllSuccess }));
    return MerchantsService.fetchMerchantsAll(params).then(
      (merchants) => {
        dispatch(fetchMerchantsSuccess(merchants));
        return merchants;
      },
      (error) => {
        dispatch(failedRequest(error, true));
        return { error: true };
      }
    );
  };

export const fetchMerchants = (filters, list) => (dispatch) => {
  dispatch(startRequest({ action: MerchantsType.actions.fetchMerchantsList, list }));
  return MerchantsService.fetchMerchantsList(filters).then(
    (Merchants) => {
      dispatch(fetchGridFiltersSuccess(list, Merchants));
      return Merchants;
    },
    (error) => {
      dispatch(failedRequest(error, true));
      return { error: true };
    }
  );
};

const fetchMerchantDetailsSuccess = createAction(MerchantsType.actions.fetchMerchantDetailsSuccess);

export const fetchMerchantDetails = () => (dispatch) => {
  return MerchantsService.fetchMerchantDetails().then(
    (details) => {
      dispatch(fetchMerchantDetailsSuccess({ details }));
      return details;
    },
    (error) => {
      dispatch(failedRequest(error));
      return { error: true };
    }
  );
};

export const fetchCountriesCurrency = () => (dispatch) => {
  return MerchantsService.fetchCountriesCurrency().then(
    (countriesCurrency) => {
      dispatch(fetchCountriesCurrencyData({ countriesCurrency }));
      return { countriesCurrency };
    },
    (error) => {
      dispatch(failedRequest(error));
      return { error: true };
    }
  );
};

export const updateMerchantCashoutLimit = (idMerchant, request) => (dispatch) => {
  dispatch(startRequest({ action: MerchantsType.actions.updateMerchantCashoutLimit }));
  return MerchantsService.updateMerchantCashoutLimit(idMerchant, request).then(
    () => {
      dispatch(successRequest());
    },
    (error) => {
      dispatch(failedRequest(error));
      return { error: true };
    }
  );
};

const fetchMerchantCurrencies = createAction(MerchantsType.actions.fetchMerchantPossibleCurrencies);
export const fetchCurrencies = (idMerchant) => async (dispatch) => {
  return MerchantsService.fetchMerchantDetailsCurrencies(idMerchant).then(
    (currencies) => {
      dispatch(fetchMerchantCurrencies({ currencies }));
      return { currencies };
    },
    (error) => {
      dispatch(failedRequest(error));
      return { error: true };
    }
  );
};
